import { IOcrEligibility } from '../../domain/operational-cost-reimbursement.model';
import { OcrActions, OcrActionTypes } from './operational-cost-reimbursement.action';

export interface OcrState {
  eligibility: IOcrEligibility | null;
  loading: boolean;
  submitting: boolean;
  submitSuccess: boolean;
  error: string | null;
}

export const initialState: OcrState = {
  eligibility: null,
  loading: false,
  submitting: false,
  submitSuccess: false,
  error: null,
};

export function ocrReducer(
  state: OcrState = initialState,
  action: OcrActions,
): OcrState {
  switch (action.type) {
    case OcrActionTypes.GetEligibility:
      return { ...state, loading: true, submitSuccess: false, error: null };
    case OcrActionTypes.GetEligibilitySuccess:
      return {
        ...state,
        loading: false,
        eligibility: action.payload,
        error: null,
      };
    case OcrActionTypes.GetEligibilityFault:
      return { ...state, loading: false, error: action.payload };

    case OcrActionTypes.SubmitClaim:
      return { ...state, submitting: true, submitSuccess: false, error: null };
    case OcrActionTypes.SubmitClaimSuccess:
      // A successful Month-1 submission always leaves Month-1 `Submitted` —
      // re-fetching the whole grid (dispatched separately by the component,
      // triggered off `submitSuccess`) is the source of truth rather than
      // hand-patching this slice's `eligibility` in place.
      return { ...state, submitting: false, submitSuccess: true, error: null };
    case OcrActionTypes.SubmitClaimFault:
      return {
        ...state,
        submitting: false,
        submitSuccess: false,
        error: action.payload,
      };

    // BRD FR-5.1 (Slice 4, BRD §21) — Verify & Submit reuses the exact same
    // submitting/submitSuccess/error transitions as SubmitClaim.
    case OcrActionTypes.VerifySubmitClaim:
      return { ...state, submitting: true, submitSuccess: false, error: null };
    case OcrActionTypes.VerifySubmitClaimSuccess:
      return { ...state, submitting: false, submitSuccess: true, error: null };
    case OcrActionTypes.VerifySubmitClaimFault:
      return {
        ...state,
        submitting: false,
        submitSuccess: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
